import React, { FC } from 'react';
import { IContentLoaderProps } from 'react-content-loader';
import {
    DescriptionBlockLoader,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/banner-loaders/description-block-loader/description-block-loader';
import {
    ImageLoader,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/banner-loaders/image-loader/image-loader';
import {
    SkeletonLoaderTypeEnum,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/skeleton/skeleton.types';
import {
    ButtonLoader,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/banner-loaders/button-loader/button-loader';
import * as Styled from './skeleton.styles';

interface ReferralPageBannersSkeleton extends IContentLoaderProps {
    type: SkeletonLoaderTypeEnum;
    width?: number;
    height?: number;
    isBottomBanner?: boolean;
    marginTop?: number;
}

export const Skeleton: FC<ReferralPageBannersSkeleton> = ({
    type,
    width,
    height,
    marginTop,
    ...restProps
}) => {
    switch (type) {
        case SkeletonLoaderTypeEnum.TEXT:
            return (
                <Styled.Skeleton height={height} marginTop={marginTop}>
                    <DescriptionBlockLoader {...restProps} />
                </Styled.Skeleton>
            );
        case SkeletonLoaderTypeEnum.BUTTON:
            return (
                <Styled.ButtonSkeleton width={width} height={height}>
                    <ButtonLoader />
                </Styled.ButtonSkeleton>
            );
        default:
            return (
                <Styled.Skeleton height={height} isImage>
                    <ImageLoader {...restProps} width={width} height={height} />
                </Styled.Skeleton>
            );
    }
};
